var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStarHalf(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 33,
    viewBox: "0 0 33 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "star_half",
    clipPath: "url(#clip0_1634_281)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M29.8104 12.4376L20.1984 11.6088L16.4418 2.75879L12.6853 11.6222L3.07324 12.4376L10.3725 18.761L8.18004 28.1591L16.4418 23.1726L24.7036 28.1591L22.5245 18.761L29.8104 12.4376ZM16.4418 20.6727V8.23991L18.7278 13.6408L24.5833 14.1488L20.1449 17.999L21.4818 23.7207L16.4418 20.6727Z",
    fill: "#F8A401"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1634_281"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32.0846,
    height: 32.0846,
    fill: "white",
    transform: "translate(0.399414 0.0849609)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStarHalf);
export default __webpack_public_path__ + "static/media/star_half.b09fdf4c4f68aceda87617b16b2a3a79.svg";
export { ForwardRef as ReactComponent };